/*
 * @Author: 未知
 * @Date: 2019-07-09 16:23:49
 * @Last Modified by: huping
 * @Last Modified time: 2020-08-10 17:45:51
 */
import React from 'react';

import initProps from './initProps';
import RobotListBody from './robotListBody';
import checkRequestAnimationFrame from './checkRequestAnimationFrame';
import timeout from './timeout';
import bindThis from './bindThis';
import helper from '../../helper/dish-helper';

import './scrollerMenu.scss';

@bindThis
@initProps
@checkRequestAnimationFrame('turbo')
class ScrollerMenu extends React.Component {
  constructor(props) {
    super(props);

    this.bind(
      'scrollAction',
      'turboAction',
      'scrollEndAction',
      'renderServingMeals',
      'renderPackage',
      'mealsListRender',
      'changeZIndex',
      // 'getRobotInfo',
      'getMealsReduceCallback',
      'selectRobot',
    );
    this.getRobotInfo = this.getRobotInfo.bind(this);

    this.scrollerMenuBody = null;

    this.saveThreshold = null;
    // 屏幕获取菜单系列区域阈值
    this.windowThresholdNum = 90;

    this.scrollTop = 0;

    this.turboExecution = false;

    this.scrollerMenuMainIndex = this.getScrollerMenuMainIndex();

    // const isEnable = this.getIsEnable();

    this.state = {
      isEnable: true,
      orderChangeList: {},
      titleMarkInfo: {},
      collectInfoAll: {
        // 总高度
        accumulationHeight: 0,
        // 屏幕总数
        screenNum: 1,
        // 队列信息
        locationGroup: {},
        // dish索引
        dishIndexList: [],
      },
      screenInfo: {
        // 之前进入的屏幕
        saveScreen: null,
        // 显示的屏幕队列
        screenRenderList: [1, 2, 3, 4, 5],
      },
      // 可视区域高度
      scrollerMenuBodyHeight: 0,
      scrollerZIndex: 'auto',
      initOver: false,
    };
  }

  /**
   * 获取菜品列表在props.children中的索引
   */
  getScrollerMenuMainIndex() {
    return this.props.children.findIndex(item => item && item.props && item.props.scrollerMenuMain);
  }

  /**
   * 是否开启分屏加载
   */
  getIsEnable() {
    const { dishesData } = this.props;
    const quantity = dishesData.length; // this.props.children[this.scrollerMenuMainIndex].props.children.length;
    const isIphone = /iphone/i.test(navigator.userAgent);
    const isIpad = /iPad/i.test(navigator.userAgent);
    return (isIphone || isIpad) && quantity > 150;
  }

  componentDidMount() {
    this.setScrollerMenuBodyHeight();
    this.actionOnce = true;
  }

  componentWillReceiveProps(nextProps) {
    if (this.scrollActionIng) return;

    if (nextProps.saveOrderChangeItem) {
      this.orderChangeRobotInfo(nextProps);
      nextProps.reinstateUndefined();
    }

    if (nextProps.changeShowData && !nextProps.saveOrderChangeItem && this.actionOnce) {
      this.actionOnce = false;
      this.orderChangeRobotInfo(nextProps, true);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.saveThreshold && this.saveThreshold.dishId === this.props.dishId) return;
    if (this.props.dishId !== prevProps.dishId) this.clickMenuChangeScroll();
  }

  // componentWillUnmount() {
  //   this.animateId && window.cancelAnimationFrame(this.animateId);
  // }

  /**
   * changShowData和saveOrderChangeItem引发的RobotInfo的变更。
   * 属实觉的下面的逻辑很是诡异。。。
   * @param {*} nextProps
   * @param {*} firstLoad
   */
  orderChangeRobotInfo(nextProps, firstLoad) {
    const { saveOrderChangeItem, changeShowData } = nextProps;
    if (firstLoad) {
      changeShowData.forEach(item => {
        this.changeRobotOrder(nextProps, item); // 第一次加载
      });
    } else if (saveOrderChangeItem === 'clearAll') {
      this.clearAllOrder(nextProps);
    } else {
      this.changeRobotOrder(nextProps);
    }
  }

  clearAllOrder(nextProps) {
    const { collectInfoAll, orderChangeList: oldOrderChangeList } = this.state;
    const changeListArray = Object.keys(oldOrderChangeList);

    (changeListArray.length ? changeListArray : Object.keys(collectInfoAll.dishIndexList)).forEach(item => {
      if (collectInfoAll.dishIndexList[item]) {
        collectInfoAll.dishIndexList[item].reduce(this.selectRobot, { collectInfoAll, nextProps });
      }
    });

    this.setState({
      collectInfoAll,
      orderChangeList: {},
    });
  }

  /**
   * 改变Robot信息
   * @param {*} nextProps
   * @param {*} firstLoadData
   */
  changeRobotOrder(nextProps, firstLoadData) {
    const { collectInfoAll, orderChangeList: oldOrderChangeList } = this.state;

    const { proxyDishId, id } = firstLoadData || nextProps.saveOrderChangeItem[0];

    const saveId = proxyDishId || id;
    const saveValue = firstLoadData ? helper.getDishesCount([firstLoadData]) : oldOrderChangeList[saveId];

    oldOrderChangeList[saveId] = (saveValue === undefined ? 0 : saveValue) + (firstLoadData ? 0 : nextProps.saveOrderChangeItem[1]);

    Array.isArray(collectInfoAll.dishIndexList[saveId]) && collectInfoAll.dishIndexList[saveId].reduce(this.selectRobot, { collectInfoAll, nextProps });

    this.setState({
      collectInfoAll,
      orderChangeList: oldOrderChangeList,
    });
  }

  selectRobot(opt, indexItem) {
    const { collectInfoAll, nextProps } = opt;
    const { screenNum, index } = indexItem;

    const robot = collectInfoAll.locationGroup[screenNum][index];

    collectInfoAll.locationGroup[screenNum][index] = this.changeRobot(robot, nextProps);

    return opt;
  }

  changeRobot(robot, nextProps) {
    // robot.robotObj = nextProps.children[this.scrollerMenuMainIndex].props.children[robot.index];
    const { dishesReactObj } = nextProps;
    if (dishesReactObj[robot.robotId]) {
      robot.robotObj = dishesReactObj[robot.robotId];
      // robot.keys = `_${Math.random()
      //   .toString(36)
      //   .substr(2, 9)}-${performance.now()}`;
    }
    return robot;
  }

  setScrollerMenuBodyHeight() {
    this.setState({
      scrollerMenuBodyHeight: (this.scrollerMenuBody && this.scrollerMenuBody.clientHeight) || 0,
    });
  }

  /**
   * 获取TobotInfo的信息
   * @param {*} feedback
   */
  getRobotInfo(feedback) {
    const { collectInfoAll, titleMarkInfo } = feedback;
    this.setState({
      collectInfoAll,
      titleMarkInfo,
      initOver: true,
    });
  }

  calcPositionInfo() {}

  checkSaveThreshold() {
    if (!this.saveThreshold) {
      const { titleMarkInfo = {} } = this.state;
      const { infoList = [] } = titleMarkInfo;
      this.saveThreshold = infoList && infoList.length !== 0 ? infoList[0] : {};
    }
  }

  checkIndex(threshold) {
    const { top, index } = this.saveThreshold;
    const { titleMarkInfo = {} } = this.state;
    const { infoList = [] } = titleMarkInfo;

    if (threshold > top) return this.downActionSelectMenuId(threshold, index, infoList);

    if (threshold < top) return this.upActionSelectMenuId(threshold, index, infoList);

    return index;
  }

  downActionSelectMenuId(threshold, index, infoList) {
    const interception = infoList.slice(index);
    const falstLength = infoList.length - interception.length;
    const findIndex = interception.findIndex(item => threshold < item.top);

    return findIndex === -1 ? infoList.length - 1 : findIndex + falstLength - 1;
  }

  upActionSelectMenuId(threshold, index, infoList) {
    const interception = infoList.slice(0, index);

    const findIndex = interception.reverse().findIndex(item => threshold > item.top);

    return findIndex === -1 ? 0 : interception.length - 1 - findIndex;
  }

  changeZIndex(indexNum) {
    this.setState({
      scrollerZIndex: indexNum,
    });
  }

  /**
   * 根据滚动高度获取第几屏
   * @param {*} scrollTop
   */
  scrollActionGetScreen(scrollTop) {
    const { scrollerMenuBodyHeight } = this.state;

    const scrollerHeightAddscrollTop = scrollTop + scrollerMenuBodyHeight;

    return Math.floor(scrollerHeightAddscrollTop / scrollerMenuBodyHeight);
  }

  /**
   * 滚动条 滚动的时候触发
   */
  scrollAction() {
    if (this.turboExecution) return;

    // if (this.state.scrollerZIndex === 'auto') this.changeZIndex(2);

    this.turboExecution = true;

    this.scrollActionIng = true;

    this.animateId = this.turbo(this.turboAction);
  }

  /**
   * 涡轮增压行为
   * 哈哈，直译。找打的行为哦。
   */
  turboAction() {
    if (this.scrollTop === this.scrollerMenuBody.scrollTop) {
      this.changeZIndex('auto');

      this.scrollEndAction();

      this.turboExecution = false;

      return;
    }

    this.scrollTop = this.scrollerMenuBody.scrollTop;

    const { onScrollingTitleAction } = this.props;

    onScrollingTitleAction(-this.scrollTop);

    if (!this.state.isEnable) {
      this.turbo(this.turboAction);

      return;
    }

    const screenNumNow = this.scrollActionGetScreen(this.scrollTop);

    const { saveScreen } = this.state.screenInfo;

    if (screenNumNow !== saveScreen && screenNumNow > -1) this.screenChange(screenNumNow);

    this.turbo(this.turboAction);
  }

  @timeout(400)
  scrollEndAction() {
    const { onScroll } = this.props;
    const { scrollTop } = this.scrollerMenuBody;

    const threshold = scrollTop + this.windowThresholdNum;

    this.checkSaveThreshold();

    const checkIndex = this.checkIndex(threshold);
    this.scrollActionIng = false;

    if (checkIndex === this.saveThreshold.index) return;

    const { titleMarkInfo } = this.state;
    const { infoList = [] } = titleMarkInfo;

    this.saveThreshold = infoList && infoList.length !== 0 ? infoList[checkIndex] : {};

    onScroll(null, this.saveThreshold.dishId, this.saveThreshold.index);
  }

  /**
   * 改变screenInfo的信息
   * 只会渲染指定屏数的上一屏和下一屏
   * 任何时候渲染三屏的数据。
   * @param {*} screenNewNumNow
   */
  screenChange(screenNewNumNow) {
    const { screenInfo } = this.state;

    screenInfo.screenRenderList = [screenNewNumNow - 1, screenNewNumNow, screenNewNumNow + 1];

    screenInfo.saveScreen = screenNewNumNow;

    this.changeScreenInfo(screenInfo);
  }

  clickMenuChangeScroll() {
    const { dishIdIndex } = this.props;
    const { titleMarkInfo } = this.state;
    const { infoList = [] } = titleMarkInfo;

    const info = infoList.filter(item => item.index === Number(dishIdIndex));

    if (info.length) {
      this.scrollerMenuBody.scrollTop = info[0].top;
    }
  }

  changeScreenInfo(screenInfo) {
    this.setState({
      screenInfo,
    });
  }
  /**
   * 获取菜品列表信息
   * 如果initOver===false 那么就直接将子元素中的子菜单直接返回出去
   */
  mealsGet() {
    const { scrollerMenuBodyHeight, initOver } = this.state;

    if (!scrollerMenuBodyHeight) return null;

    if (!initOver) return null; // this.props.children[this.scrollerMenuMainIndex].props.children;

    const mealsShow = this.renderServingMeals();

    return mealsShow.map(item => {
      const { top, className, dishId, robotObj, keys, left, width, height } = item;

      return (
        <li
          key={keys}
          className={className}
          data-id={dishId}
          style={{
            position: 'absolute',
            width,
            top,
            left,
            height,
          }}
        >
          {robotObj.props.children}
        </li>
      );
    });
  }

  /**
   * list渲染
   */
  mealsListRender() {
    const { children, theme } = this.props;
    const { scrollerZIndex, collectInfoAll } = this.state;
    const meals = this.mealsGet();
    const mature = this.renderPackage(meals);

    const isDefault = `${theme !== 'default' && theme !== 'tea' ? 'dish-scroller-main-big' : ''}`;
    return (
      <div
        className={`dish-scroller dish-scroller-main ${isDefault}`}
        onScroll={this.scrollAction}
        ref={element => (this.scrollerMenuBody = element)}
        style={{ zIndex: scrollerZIndex }}
        id="snailScroll"
      >
        {/* 注意，这里的copyright似乎没有啥用一样。外卖 */}
        <div
          className={'copyright copyright--dish-scroller dish-scroller-action'}
          style={{
            position: 'relative',
            height: collectInfoAll.accumulationHeight,
          }}
        >
          <div>
            {children[0]}
            {children[1]}
            {mature}
            {/* 这个span是纯粹为了占空间？？？？？ */}
            {/* <span style={{ width: '100%', height: '90px', display: 'block' }} /> */}
          </div>
        </div>
      </div>
    );
  }

  selectMeals() {
    const { screenInfo, collectInfoAll, isEnable } = this.state;
    return isEnable ? screenInfo.screenRenderList : Object.keys(collectInfoAll.locationGroup);
  }

  /**
   * 渲染菜品
   */
  renderPackage(mealsRobot) {
    const { scrollerMenuBodyHeight } = this.state;
    const { children, dishTypesData, dishesData, theme, isHDL, isZc, hasAds } = this.props;
    if (!scrollerMenuBodyHeight) return null;
    // if (!mealsRobot) return children[this.scrollerMenuMainIndex].props.children;

    return (
      <RobotListBody
        className="dish-list clearfix"
        dishesData={dishesData}
        dishTypesData={dishTypesData}
        parentBodyHeight={scrollerMenuBodyHeight}
        getRobotInfo={this.getRobotInfo}
        theme={theme}
        isHDL={isHDL}
        isZc={isZc}
        hasAds={hasAds}
      >
        {mealsRobot}
      </RobotListBody>
    );
  }

  getMealsReduceCallback(renderAccumulationList, screenNum) {
    if (screenNum <= 0) return renderAccumulationList;

    const mealsList = this.state.collectInfoAll.locationGroup[screenNum];

    if (mealsList) return renderAccumulationList.concat(mealsList);

    return renderAccumulationList;
  }

  renderServingMeals() {
    return this.selectMeals().reduce(this.getMealsReduceCallback, []);
  }

  render() {
    return this.mealsListRender();
  }
}

export default ScrollerMenu;



// WEBPACK FOOTER //
// ./src/container/dish-scroller-menu/scrollerMenu.jsx